export const salutations = ["Dr.", "Miss", "Mr.", "Mrs.", "Ms."];
export const countryCodes = [
  "+1",
  "+1-242",
  "+1-246",
  "+1-264",
  "+1-268",
  "+1-284",
  "+1-340",
  "+1-345",
  "+1-441",
  "+1-473",
  "+1-649",
  "+1-664",
  "+1-670",
  "+1-671",
  "+1-684",
  "+1-721",
  "+1-758",
  "+1-767",
  "+1-784",
  "+1-809",
  "+1-829",
  "+1-849",
  "+1-868",
  "+1-869",
  "+1-876",
  "+20",
  "+211",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+27",
  "+290",
  "+291",
  "+297",
  "+298",
  "+299",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+36",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+379",
  "+380",
  "+381",
  "+382",
  "+385",
  "+386",
  "+387",
  "+389",
  "+39",
  "+40",
  "+41",
  "+420",
  "+421",
  "+423",
  "+43",
  "+44",
  "+45",
  "+46",
  "+47",
  "+48",
  "+49",
  "+500",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+590",
  "+591",
  "+592",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+599",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+670",
  "+672",
  "+673",
  "+674",
  "+675",
  "+676",
  "+677",
  "+678",
  "+679",
  "+680",
  "+681",
  "+682",
  "+683",
  "+685",
  "+686",
  "+687",
  "+688",
  "+689",
  "+690",
  "+691",
  "+692",
  "+7",
  "+81",
  "+82",
  "+84",
  "+850",
  "+852",
  "+853",
  "+855",
  "+856",
  "+86",
  "+870",
  "+880",
  "+886",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+960",
  "+961",
  "+962",
  "+963",
  "+964",
  "+965",
  "+966",
  "+967",
  "+968",
  "+970",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+98",
  "+992",
  "+993",
  "+994",
  "+995",
  "+996",
  "+998",
];
export const usStates = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export const researchAreas = {
   "I. Corporate Finance":[
      "AI & Data-Privacy Regulation",
      "AI Capital Expenditures & Data Centers",
      "Alternative Financing",
      "Bank Corporate Lending (Basel III)",
      "Buybacks vs. Dividends",
      "Capital Budgeting",
      "Capital Structure",
      "Compensation Metrics & Risk-Taking",
      "Corporate Distress & Restructuring",
      "Corporate Governance",
      "Cost of Capital & Term Premium",
      "Cyber Risk, Insurance & Financing",
      "Energy-Transition Real Options",
      "Family Firms",
      "Firm Valuation",
      "Foreign Exchange & Capital Budgeting",
      "Geopolitics, Trade & Supply Chains",
      "Hedging & Risk Management",
      "Initial Public Offerings (IPOs)",
      "Intangibles: R&D, Software & Data",
      "Key Performance Indicators (KPIs)",
      "Liability Management",
      "Mergers & Acquisitions (M&A) ",
      "Payout Policy",
      "Shareholder Activism & Governance",
      "SPACs & Direct Listings",
      "Spin-Offs, Carve-Outs & Divestitures",
      "Sustainable Finance",
      "Working Capital Management"
   ],
   "II. Financial Accounting":[
      "Business Combinations & Consolidation",
      "Cash Flow Statement",
      "Derivatives & Hedging",
      "Earnings Management & Reporting Quality",
      "EPS & Capital Structure",
      "Fair Value & Impairment",
      "Financial Instruments & Credit Losses",
      "Financial Statement Analysis",
      "Foreign Currency Reporting",
      "Income Taxes & Deferred Taxes",
      "Internal Control over Financial Reporting",
      "Leases & Off-Balance-Sheet",
      "Market-Based Accounting",
      "Revenue Recognition",
      "Share-Based Compensation",
      "Sustainability & Climate Reporting"
   ],
   "III. Financial Markets and Institutions":[
      "Currency Markets",
      "Emerging Markets",
      "Energy Markets",
      "Exchange Rates",
      "Financial Crisis",
      "Financial Systems",
      "FX Trading",
      "Institutional Investors",
      "Integration",
      "Market Anomalies and Efficiency",
      "Market Bubbles",
      "Market Microstructure",
      "Market Regulation and Disclosure",
      "Money and Capital",
      "Spillover Effects",
      "Trading & Short Selling"
   ],
   "IV. Investments & Portfolio Management":[
      "AI/ML in Investing",
      "Asset Allocation & Rebalancing",
      "Behavioral Finance & Flows",
      "Digital Assets & Tokenization",
      "Direct Indexing & Tax Management",
      "ETFs: Active & Market Structure",
      "Factor Investing & Anomalies",
      "Fixed Income & the 60/40 Rule",
      "Manager Selection & Due Diligence",
      "Microstructure, Liquidity & T+1",
      "Options & Structured Outcomes",
      "Performance, Benchmarking & Attribution",
      "Private Markets (PE, Credit, Real Assets)",
      "Retirement Investing & Decumulation",
      "Risk Management & Overlays",
      "Sustainable & Climate Investing"
   ],
   "V. Derivatives":[
      "AI/ML for Derivatives",
      "Clearing & Collateral",
      "Commodity Derivatives",
      "Crypto & DeFi Derivatives",
      "Energy & Power Derivatives",
      "Forwards & Futures",
      "FX Derivatives",
      "Insurance-Linked & Cat Bonds",
      "Interest-Rate Derivatives",
      "Option Pricing & Greeks",
      "Options Overlays",
      "Post-LIBOR & RFRs",
      "Risk Management & Hedging",
      "Zero-Days-to-Expiry Options (0DTE)"
   ],
   "VI. Quantitative Finance":[
      "Asset Pricing & Machine Learning (ML)",
      "Causal Inference & Causal ML",
      "Carbon & Sustainability-Linked Derivatives",
      "Credit, XVA & Capital",
      "Execution, Microstructure & Liquidity",
      "Graph ML & Network Finance",
      "Large Language Models (LLMs) for Finance",
      "Numerical Methods & High-Performance Computing",
      "Optimal Transport & Wasserstein Methods",
      "Portfolio Optimization & Decision",
      "Probability Distributions, Risk, & Asset Prices",
      "Stochastic Calculus & Panel Methods",
      "Stochastic Control & Reinforcement Learning",
      "Time-Series & Regimes",
      "Volatility & High-Frequency"
   ],
   "VII. Other Topics":[
      "Central Bank Digital Currencies (CBDCs)",
      "Climate & Carbon Markets",
      "Climate Risk & Financial Stability",
      "Crypto Market Structure",
      "Decentralized Finance (DeFi)",
      "Diversity, Equity, and Inclusion (DEI)",
      "Socially Responsible Investing (SRI)",
      "Ethical Issues in Finance",
      "Federated & Privacy-Preserving Analytics",
      "Financial Literacy & Education",
      "FinTech & Digital Finance",
      "Islamic Finance",
      "Political Economy & Finance",
      "Public Finance & Fiscal Policy",
      "Quantum-Inspired Optimization",
      "Real Estate Finance & Economics",
      "Shadow Banking",
      "Term Structure & Macro-Finance",
      "Tokenization & Real-World Assets (RWA)"
   ]   
};

export const manuscriptTypes = [
  "Regular Paper", 
  "Invited Paper", 
  "Doctoral Paper"
];

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
